export enum EnumBooleanStringifiedExtended {
  TRUE = "true",
  TRUTHY = "1",
  FALSE = "false",
  FALSY = "0",
}
